export default __webpack_public_path__ + "static/media/kausi15-min.160c3e80.jpg";